const steps = [
  {
    num: "01",
    title: "Start Your Application Online",
    desc: "Choose your service type and processing speed. We\u2019ll send you a tailored document checklist for your Sioux Falls application.",
  },
  {
    num: "02",
    title: "Gather Your Documents",
    desc: "Use our checklist to collect everything needed. Your dedicated agent reviews each item for accuracy before submission.",
  },
  {
    num: "03",
    title: "Visit a Local Acceptance Facility",
    desc: "Bring your documents to a Sioux Falls acceptance facility (post office or clerk\u2019s office). They verify your identity and seal the application.",
  },
  {
    num: "04",
    title: "Ship to Fast Passport Center",
    desc: "Mail your sealed application to our office via overnight shipping. We receive it the next business day and begin processing immediately.",
  },
  {
    num: "05",
    title: "We Submit to the Passport Agency",
    desc: "As a registered courier, we hand-deliver your application to a U.S. passport agency. No Denver trip required for Sioux Falls residents.",
  },
  {
    num: "06",
    title: "Receive Your Passport Fast",
    desc: "Your passport is delivered directly to your Sioux Falls address. 2\u20139 day processing available for most applicants.",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Simple Steps to Your Passport in Sioux Falls
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            No guesswork. No agency lines. Our registered courier service handles the complex parts so you can focus on your trip.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all duration-200">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] text-[#F6C344] font-bold text-sm mb-4">
                {step.num}
              </div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Application <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}